import {ErrorPageComponent} from './error-page';
import {MainPageComponent} from './main-page';
import {Transition} from '@uirouter/core';
import {ApiService} from "../utils/api.service";

export const ErrorState = {
    name: 'error500',
    url: '/error500',
    component: ErrorPageComponent,
    page: 'error',
    title: 'Something Went Wrong'
};

export const MainState = {
    name: 'main',
    url: '/?auth&error&oauth&client_id&client_secret&redirect_uri&response_type&page&promo&state',
    component: MainPageComponent,
    page: 'home',
    title: 'Welcome',
    params: {
        client_id: {type: 'any'},
        client_secret: {type: 'any'},
        redirect_uri: {type: 'any'},
        response_type: {type: 'any'},
        error: {type: 'any'},
        oauth: {type: 'any'},
        auth: {type: 'any'},
        page: {type: 'any'},
        promo:{type: 'any'},
        state:{type: 'any'}
    },
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.redirect_uri){
                    params.redirect_uri = decodeURIComponent(decodeURIComponent(params.redirect_uri));
                }

                if (params.error){
                    params.error = decodeURIComponent(params.error).replace(/\+/gi,' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};
